<template>
    <div class="home-page">
        <div class="container">
            <!-- 导航栏 -->
            <div class="tab-menu" :style="{background: menuStyle}">
                <div :class="['logo-box', isCollapse ? 'hide' : 'show']">森科物联</div>
                <el-scrollbar style="height: calc(100% - 76px);">
                    <el-menu
                        :default-active="activePath"
                        class="el-menu-vertical-demo"
                        text-color="#ffffff"
                        background-color="transparent"
                        active-text-color="#ffffff"
                        :collapse="isCollapse"
                        unique-opened
                        @select="selectMenu"
                    >
                        <el-menu-item index="/home">
                            <i class="iconfont iconshouye1"></i>
                            <span slot="title">首页</span>
                        </el-menu-item>
                        <el-submenu :index="item.name" v-for="(item, index) in getMenu" :key="index">
                            <template slot="title">
                                <i :class="['iconfont', item.iconPath]"></i>
                                <span slot="title">{{ item.name }}</span>
                            </template>
                            <el-menu-item :index="e.url" v-for="(e, i) in item.menus" :key="i">{{ e.menuName }}</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-scrollbar>
            </div>

            <!-- 右侧区域 -->
            <div class="main">
                <div class="header">
                    <div class="item">
                        <div @click="handleNavMenu">
                            <i class="iconfont iconmenu"></i>
                        </div>
                    </div>
                    <div class="item">
                        <div v-if="getUserInfo">
                            <el-popover placement="bottom" width="250" trigger="hover">
                                <InfoCard />
                                <div slot="reference" class="headImg">
                                    <div class="headImgMain">
                                        <img :src="getUserInfo.photoPath ? '/staticfile/' + getUserInfo.photoPath : require('@/assets/images/nohead.png')"/>
                                        {{ getUserInfo.userName }}
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                        <!-- <div>
                            <el-badge is-dot>
                                <i class="iconfont icon_warn"></i>
                            </el-badge>
                        </div> -->
                        <div @click="logout">
                            <i class="iconfont icon_exit"></i>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb" v-show="$route.path != '/home'">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item
                            v-for="(item, index) in breadcrumb"
                            :key="index"
                        >
                            <span :class="index == (breadcrumb.length - 1) ? '' : 'text'" @click="breadcrumbClick(index, breadcrumb)">{{ item.title }}</span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                    <el-button
                        v-show="breadcrumb.length > 1"
                        type="primary"
                        @click="$router.back(-1)"
                    >返回</el-button>
                </div>

                <div :class="['content-wrap', $route.meta.fatherContanier || '']">
                    <div class="main-content">
                        <navigation>
                            <transition name="fade">
                                <router-view></router-view>
                            </transition>
                        </navigation>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InfoCard from './components/InfoCard';
import { mapGetters } from 'vuex';
import { debounce } from '@/common/utils';
export default {
    data() {
        return {
            activePath: '', // 当前激活的菜单
            isCollapse: false, // 导航栏是否折叠
            breadcrumb: [] // 面包屑
        };
    },
    components: {
        InfoCard
    },
    computed: {
        ...mapGetters(['getUserInfo', 'getMenu']),
        // 系统差异
        menuStyle() {
            return 'linear-gradient(-22deg,rgba(5, 79, 218, 1),rgba(0, 127, 245, 1))'
        }
    },
    created() {
        // 存储菜单
        this.$store.dispatch('updateMenu');
    },
    mounted() {
        // console.log(this.SYSTEM)
        this.listenScreen();
    },
    methods: {
        // 展开/收拢导航栏
        handleNavMenu() {
            this.isCollapse = !this.isCollapse;
        },
        // 监听屏幕缩放
        listenScreen() {
            window.onresize = debounce(() => {
                if (document.body.clientWidth <= 1366) {
                    this.isCollapse = true;
                } else {
                    this.isCollapse = false;
                }
            }, 300);
        },
        // 选择菜单时
        selectMenu(index) {
            this.$navigation.cleanRoutes(); // 清空路由记录
            this.$router.push(index);
        },
        // 注销
        logout() {
            this.$http.get('/logout', {}, '注销中……').then(() => {
                this.$navigation.cleanRoutes();
                this.$store.commit('clearStorage');
                this.$router.push('/');
                this.$message.success('注销成功');
            })
        },
        // 面包屑点击事件
        breadcrumbClick(index, breadcrumb) {
            let step = index - (breadcrumb.length - 1);
            step == 0 || this.$router.go(step);
        }
    },
    watch: {
        $route: {
            handler(to, from) {
                // console.log(to, from)
                // 主菜单之间切换时，储存当前激活的菜单
                if (to.meta.index == 1) {
                    sessionStorage.setItem('activePath', to.path);
                }
                // 获取存储的激活菜单
                let path = sessionStorage.getItem('activePath');
                if (path) {
                    this.activePath = path;
                }
                // 获取存储的面包屑
                let breadcrumb = sessionStorage.getItem('breadcrumb');
                if (breadcrumb) {
                    this.breadcrumb = JSON.parse(breadcrumb);
                }
                switch (true) {
                    case to.name == 'home':
                        this.breadcrumb = [{
                            path: to.path,
                            title: to.meta.title
                        }];
                        break;
                    case !from:
                        break;
                    case from.meta.index < to.meta.index:
                        if ((to.meta.index - from.meta.index) > 1) {
                            this.breadcrumb = [];
                        }
                        this.breadcrumb.push({
                            path: to.path,
                            title: to.meta.title
                        });
                        break;
                    case from.meta.index == to.meta.index:
                        this.breadcrumb.pop();
                        this.breadcrumb.push({
                            path: to.path,
                            title: to.meta.title
                        });
                        break;
                    case from.meta.index > to.meta.index:
                        let step = from.meta.index - to.meta.index + 1;
                        let len = this.breadcrumb.length;
                        this.breadcrumb.splice(len - step, step);
                        this.breadcrumb.push({
                            path: to.path,
                            title: to.meta.title
                        });
                        break;
                }
                // 如果子路由中query含有name，则更新title为name
                this.$set(this.breadcrumb, this.$route.meta.index - 1, {
                    path: this.$route.path,
                    title: this.$route.query.name ? this.$route.query.name : this.$route.meta.title
                });
                // 存储面包屑
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify(this.breadcrumb)
                );
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    .tab-menu {
        height: 100vh;
        border-right: 1px solid transparent;
        .logo-box {
            line-height: 76px;
            color: #fff;
            font-size: 24px;
            text-align: center;
            transition: all 0.3s;
        }
        .hide {
            opacity: 0;
            width: 0;
            height: 0;
        }
        .show {
            opacity: 1;
            width: 200px;
            height: 76px;
        }
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden !important;
        }
        .el-menu {
            height: 100%;
            border-right: 0;
        }
    }
    .main {
        flex: 1;
        background: #f5f7fa;
        overflow: hidden;
        .header {
            height: 48px;
            background-color: #fff;
            box-shadow: 0px 1px 2px 0px rgba(221, 232, 237, 1);
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .item {
                height: 100%;
                display: flex;
                align-items: center;
                & > div {
                    height: 100%;
                    padding: 0 12px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .iconfont {
                        color: #bac9d7;
                        font-size: 20px;
                    }
                    &:hover {
                        color: $primary;
                        .iconfont {
                            color: $primary;
                            font-size: 20px;
                        }
                    }
                }
                .headImg {
                    // position: relative;
                    height: 48px;
                    line-height: 48px;
                    .headImgMain {
                        display: flex;
                        align-items: center;
                        img {
                            height: 30px;
                            width: 30px;
                            border-radius: 50%;
                            margin-right: 10px;
                            object-fit: cover;
                        }
                    }
                }
            }
        }
        .breadcrumb {
            height: 60px;
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-breadcrumb {
                line-height: 60px;
                .text {
                    cursor: pointer;
                    font-weight: bold;
                }
            }
        }
        .content-wrap {
            height: calc(100vh - 60px - 48px - 20px);
            padding: 5px 30px;
            box-sizing: border-box;
            overflow-y: auto;
            .main-content {
                padding: 20px;
                overflow-y: auto;
                box-sizing: border-box;
                max-height: 100%;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 1px 4px 0px rgba(201, 209, 204, 0.55);
                border-radius: 4px;
            }
        }
        .content-wrap-1 {
            height: calc(100vh - 60px - 20px);
            margin-top: 20px;
            .main-content {
                padding: 0;
                height: 100%;
            }
        }
        .content-wrap-2 {
            height: calc(100vh - 60px - 48px - 20px);
            .main-content {
                padding: 20px 0;
                height: 100%;
            }
        }
    }
}
</style>

<style lang="scss">
.fade-enter-active {
    opacity: 1;
    transition: all 0.5s ease;
    transform: translateY(0);
}
.fade-leave-active {
    opacity: 0;
}
.fade-enter {
    opacity: 0;
    transform: translateY(20px);
}

.home-page {
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
    }
    // 菜单图标
    .el-menu-item i {
        color: #fff;
    }
    // 箭头
    .el-submenu__title i {
        color: #fff;
    }
    .el-menu-item,
    .el-submenu__title {
        height: 48px;
        line-height: 48px;
    }
    // 子菜单
    .el-submenu .el-menu {
        padding-left: 26px;
        box-sizing: border-box;
        background-color: var(--menuColor) !important;
    }
    // 子菜单元素
    .el-submenu .el-menu-item {
        height: 36px;
        line-height: 36px;
        margin: 5px 0;
        border-top-left-radius: 9999px;
        border-bottom-left-radius: 9999px;
    }
}
.el-submenu {
    background: transparent;
    .iconfont {
        color: $primary !important;
        font-size: 20px;
        margin-right: 10px;
    }
}
.el-menu-item {
    .iconfont {
        color: $primary !important;
        font-size: 20px;
        margin-right: 10px;
    }
}
.el-menu-item.is-active {
    .iconfont {
        color: #fff !important;
    }
}
// hover
.el-menu-item,
.el-submenu__title {
    &:hover {
        background-color: rgba(14, 221, 240, 0.32) !important;
    }
}
// 激活状态
.el-menu-item.is-active {
    background-color: $primary !important;
    &:hover {
        background-color: $primary !important;
    }
}
// 右侧nav背景色
.el-menu--popup-right-start {
    background-color: var(--menuColor) !important;
}
// 收缩时动态菜单
.el-menu-item,
.el-submenu__title {
    height: 36px;
    line-height: 36px;
}
</style>